import { PurchaseOrderStatusPipe } from './purchase-order.status.pipe';

export function PurchaseOrderStatusFilter ( purchaseOrderStatusPipe : PurchaseOrderStatusPipe ) {
  return ( value : string ) : string => purchaseOrderStatusPipe.transform(value);
}